var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresaveRelease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2204 30.8652V33.9486H6.26204C4.55917 33.9486 3.17871 32.5681 3.17871 30.8652V6.19857C3.17871 4.49569 4.55917 3.11523 6.26204 3.11523H30.9287C32.6316 3.11523 34.012 4.49569 34.012 6.19857V21.6152H30.9287V6.19857H6.26204V30.8652H23.2204ZM18.5954 11.0254V18.7476C18.1089 18.6065 17.5889 18.531 17.0537 18.531C14.58 18.531 12.4287 20.1445 12.4287 22.3852C12.4287 24.6259 14.58 26.2394 17.0537 26.2394C19.5274 26.2394 21.6787 24.6259 21.6787 22.3852V16.7867L23.9069 18.2721L25.6172 15.7066L18.5954 11.0254ZM26.3037 32.4069H29.387V35.4902H32.4704V32.4069H35.5537V29.3236H32.4704V26.2402H29.387V29.3236H26.3037V32.4069ZM18.5951 22.3861C18.5951 22.6997 17.9854 23.1569 17.0534 23.1569C16.1213 23.1569 15.5117 22.6997 15.5117 22.3861C15.5117 22.0725 16.1213 21.6152 17.0534 21.6152C17.9854 21.6152 18.5951 22.0725 18.5951 22.3861Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresaveRelease);
export default __webpack_public_path__ + "static/media/presave-release.fe904a17.svg";
export { ForwardRef as ReactComponent };